import React, { useState } from 'react';
import BrushIcon from '@mui/icons-material/Brush';

import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import styles from './ContactCard.module.scss';
import MessageModal from '../message-modal/MessageModal';

interface ContactDropdownProps {
  /** Base id used for click tracking (Google Analytics). */
  id?: string;
  onEdit: () => void;
  onDelete: () => void;
}

export const ContactDropdown = ({ id, onEdit, onDelete }: ContactDropdownProps) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [deleteMessageModalOpen, setDeleteMessageModalOpen] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {deleteMessageModalOpen && (
        <MessageModal
          open={deleteMessageModalOpen}
          modalTitle={t('messages.deleteContact')}
          modalMessage={t('messages.deleteBusinessContactDialog')}
          actionButtonText={t('buttons.goBack')}
          actionButtonFn={() => setDeleteMessageModalOpen(false)}
          goBackButtonText={t('buttons.delete')}
          onDismiss={() => setDeleteMessageModalOpen(false)}
          onClose={() => {
            onDelete();
          }}
        />
      )}
      <IconButton
        id={`${id ?? 'contactCardContactDropDown'}MoreOptionsIconBtn`}
        aria-label={t('labels.menuButton')}
        onClick={handleClick}
        className={styles.add_button_size}
      >
        <MoreVertIcon id={`${id ?? 'contactCardContactDropDown'}MoreOptionsIconBtnMoreVertIcon`} />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          id={`${id ?? 'contactCardContactDropDown'}EditMenuItem`}
          onClick={() => {
            handleClose();
            onEdit();
          }}
        >
          <BrushIcon
            id={`${id ?? 'contactCardContactDropDown'}EditMenuItemBrushIcon`}
            style={{ marginRight: 8 }}
          />
          {t('buttons.edit')}
        </MenuItem>
        <MenuItem
          id={`${id ?? 'contactCardContactDropDown'}DeleteMenuItem`}
          onClick={() => {
            handleClose();
            setDeleteMessageModalOpen(true);
          }}
        >
          <DeleteIcon
            id={`${id ?? 'contactCardContactDropDown'}DeleteMenuItemDeleteIcon`}
            style={{ marginRight: 8 }}
          />
          {t('buttons.delete')}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ContactDropdown;
